import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "SachberichtModalCreate",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {
        tab_sichtbar: false,
      },
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "sbv_kbez",
            type: "text",
            label: "_LBL_MODAL_CREATE_SACHBERICHTVORLAGE_KBEZ_",
            required: true,
            view: "v",
          },
          {
            id: "sbv_bez",
            type: "richtext",
            label: "_LBL_MODAL_CREATE_SACHBERICHTVORLAGE_BEZ_",
            view: "v-alt",
          },
        ],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  methods: {
    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);
      this.postHttp({ url: `sachberichtvorlagen/`, data }).then(
        response => {
          this.addNotification({ text: "_MSG_SACHBERICHT_MODAL_CREATE_SUCCESS_" });
          this.close();
          this.$goTo("root.sachberichtvorlagen.detail", { id: response.pk });
        },
        error => {
          this.errors = error.data;
          this.errorsClone = error.data;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
